import { FeatureFlags } from "@/constants/featureFlags";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { useMemo } from "react";

export const FALLBACK_RECOMMENDED_HARDWARE_NAMES = ["h100"];
export const FALLBACK_MOST_DEPLOYED_HARDWARE_NAMES = ["a100"];

const normalizeHardwareNames = (names: string[] | undefined, fallback: string[]) =>
  (names ?? fallback).map((name) => name.toLowerCase());

export const useHardwareTagNames = () => {
  const hardwareTagsVariant = useFeatureFlag(FeatureFlags.HARDWARE_TAGS);
  const isHardwareTagsEnabled =
    hardwareTagsVariant && hardwareTagsVariant.value !== "control" ? true : false;

  const recommendedHardwareNames = useMemo(
    () =>
      normalizeHardwareNames(
        hardwareTagsVariant?.payload?.recommended,
        FALLBACK_RECOMMENDED_HARDWARE_NAMES
      ),
    [hardwareTagsVariant?.payload?.recommended]
  );
  const mostDeployedHardwareNames = useMemo(
    () =>
      normalizeHardwareNames(
        hardwareTagsVariant?.payload?.mostDeployed,
        FALLBACK_MOST_DEPLOYED_HARDWARE_NAMES
      ),
    [hardwareTagsVariant?.payload?.mostDeployed]
  );

  return {
    isHardwareTagsEnabled,
    recommendedHardwareNames,
    mostDeployedHardwareNames
  };
};
